/* Swim PDP: grouped colour swatches (core / limited / sale) + reel play button. No dependencies. */
(function () {
  if (window.__swimPdpLoaded) return;
  window.__swimPdpLoaded = true;

  var TOKEN = '2e2e773084da602027c240088cb9f6c4';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n, sym) {
    var v = parseFloat(n);
    return sym + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  class SwimColours extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.query = this.dataset.query;
      this.currentId = this.dataset.currentProduct;
      if (!this.query) return;
      this.load();
    }

    async load() {
      var endpoint = (window.theme && window.theme.routes && window.theme.routes.storefrontAPI) || '/api/2024-07/graphql.json';
      var q = this.query.replace(/"/g, '\\"');
      var body = '{ products(first: 100, query: "title:' + q + '*") { edges { node { id title handle availableForSale onlineStoreUrl tags priceRange { minVariantPrice { amount } } compareAtPriceRange { maxVariantPrice { amount } } } } } }';
      try {
        var res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'X-Shopify-Storefront-Access-Token': TOKEN, 'Content-Type': 'application/graphql' },
          body: body
        });
        var json = await res.json();
        this.render(json.data.products.edges.map(function (e) { return e.node; }));
      } catch (err) {
        console.log('swim-colours', err);
        var block = this.closest('.product__block');
        if (block) block.style.display = 'none';
      }
    }

    group(p) {
      var price = parseFloat(p.priceRange.minVariantPrice.amount);
      var compare = parseFloat(p.compareAtPriceRange.maxVariantPrice.amount || 0);
      var tags = p.tags.map(function (t) { return t.toLowerCase(); });
      if (compare > price) return 'sale';
      if (tags.indexOf('corerange') > -1) return 'core';
      return 'limited';
    }

    render(products) {
      var self = this;
      var ds = this.dataset;
      var hideSoldSale = ds.hideSoldoutSale === 'true';
      var groups = { core: [], limited: [], sale: [] };
      var currentGroup = null;
      var salePrice = null;

      products.forEach(function (p) {
        var parts = p.title.split(' - ');
        if (parts.length < 2 || parts[0] !== self.query || !p.onlineStoreUrl) return;
        var g = self.group(p);
        var id = p.id.split('/').pop();
        var isCurrent = id === self.currentId;
        if (g === 'sale' && !p.availableForSale && hideSoldSale && !isCurrent) return;
        var colour = parts[parts.length - 1];
        var handle = colour.toLowerCase().replace(/ /g, '').replace(/\//g, '');
        if (isCurrent) currentGroup = g;
        var sp = parseFloat(p.priceRange.minVariantPrice.amount);
        if (g === 'sale') {
          salePrice = salePrice === null ? sp : Math.min(salePrice, sp);
        }
        groups[g].push({ price: sp, id: id, colour: colour, handle: p.handle, img: ds.fileStructure.replace('colour', 'swatch-' + handle), available: p.availableForSale, current: isCurrent });
      });

      var total = groups.core.length + groups.limited.length + groups.sale.length;
      if (total < 2) {
        var block = this.closest('.product__block');
        if (block) block.style.display = 'none';
        return;
      }

      var labels = {
        core: ds.coreLabel || 'Core colours',
        limited: ds.limitedLabel || 'Limited edition',
        sale: (ds.saleLabel || 'Sale') + (salePrice !== null && ds.showSalePrice === 'true' ? ' ' + money(salePrice, ds.currency || '$') : '')
      };
      var order = ['core', 'limited', 'sale'].filter(function (g) { return groups[g].length; });
      /* Bamboo: split the Sale group by price (e.g. SALE $54 / SALE $27) when a style has more than one sale price */
      if (ds.splitSalePrice === 'true' && groups.sale.length) {
        var prices = [];
        groups.sale.forEach(function (s) { if (prices.indexOf(s.price) < 0) prices.push(s.price); });
        if (prices.length > 1) {
          prices.sort(function (a, b) { return b - a; });
          var keys = prices.map(function (pr, i) {
            var k = 'sale' + i;
            groups[k] = groups.sale.filter(function (s) { return s.price === pr; });
            labels[k] = (ds.saleLabel || 'Sale') + ' ' + money(pr, ds.currency || '$');
            return k;
          });
          order.splice.apply(order, [order.indexOf('sale'), 1].concat(keys));
        }
      }

      function swatch(s) {
        return '<a class="swim-sw' + (s.current ? ' is-current' : '') + (s.available ? '' : ' is-soldout') + '" href="/products/' + esc(s.handle) + '" title="' + esc(s.colour) + (s.available ? '' : ' (sold out)') + '" style="background-image:url(' + esc(s.img) + ')"' + (s.current ? ' aria-current="true"' : '') + '><span class="visually-hidden">' + esc(s.colour) + '</span></a>';
      }

      var html = '';
      var showTabs = ds.showTabs !== 'false' && order.length > 1;
      if (showTabs) {
        html += '<div class="swim-colours__tabs" role="tablist">';
        html += '<button type="button" role="tab" class="swim-colours__tab is-active" data-g="all" aria-selected="true">All <span>' + total + '</span></button>';
        order.forEach(function (g) {
          var short = g === 'core' ? 'Core' : g === 'limited' ? 'Limited' : g === 'sale' ? 'Sale' : labels[g];
          html += '<button type="button" role="tab" class="swim-colours__tab swim-colours__tab--' + g + '" data-g="' + g + '" aria-selected="false">' + short + ' <span>' + groups[g].length + '</span></button>';
        });
        html += '</div>';
      }
      order.forEach(function (g) {
        html += '<div class="swim-colours__group swim-colours__group--' + (g.indexOf('sale') === 0 ? 'sale' : g) + '" data-g="' + g + '">';
        html += '<div class="swim-colours__glabel">' + esc(labels[g]) + '</div>';
        html += '<div class="swim-colours__row">' + groups[g].map(swatch).join('') + '</div></div>';
      });
      this.innerHTML = html;

      this.querySelectorAll('.swim-colours__tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var g = btn.dataset.g;
          self.querySelectorAll('.swim-colours__tab').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          self.querySelectorAll('.swim-colours__group').forEach(function (el) {
            el.hidden = !(g === 'all' || el.dataset.g === g);
          });
        });
      });
    }
  }
  if (!customElements.get('swim-colours')) customElements.define('swim-colours', SwimColours);

  /* Reel: tap to play with sound */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-swim-reel-play]');
    if (!btn) return;
    var wrap = btn.closest('.swim-reel__media');
    var v = wrap && wrap.querySelector('video');
    if (!v) return;
    v.muted = false;
    v.controls = true;
    v.play();
    btn.hidden = true;
  });
})();

/* Sticky add to bag: don't let it add the default size before a size is chosen */
(function () {
  function init() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;
    var btn = bar.querySelector('[data-add-to-cart]');
    var txt = btn && btn.querySelector('[data-add-to-cart-text]');
    var opts = bar.querySelector('.sticky-atc-bar__meta-options');
    var chg = bar.querySelector('[data-change-option-trigger]');
    if (chg && !chg.dataset.origLabel) chg.dataset.origLabel = chg.textContent.trim();
    var chgLabel = (chg && chg.dataset.origLabel) || 'Change';
    var picker = document.querySelector('.product__variants-wrapper');
    if (!btn || !txt || !picker) return;
    var chips = picker.querySelectorAll('.product__chip');
    if (chips.length <= 1) return;
    var chosen = function () { return !!picker.querySelector('.product__chip.selected'); };
    var sync = function () {
      if (chosen()) {
        bar.classList.remove('is-choose-size');
        if (txt.textContent.trim() === 'Choose Size') txt.textContent = btn.dataset.langAvailable || 'Add to Bag';
        if (opts) opts.hidden = false;
        if (chg) chg.textContent = chgLabel;
      } else {
        bar.classList.add('is-choose-size');
        txt.textContent = 'Choose Size';
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (opts) { opts.textContent = 'Select a size'; opts.hidden = true; }
        if (chg) chg.textContent = 'Select a size';
      }
    };
    btn.addEventListener('click', function (e) {
      if (chosen()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, true);
    picker.addEventListener('click', function () { setTimeout(sync, 50); });
    new MutationObserver(function () { setTimeout(sync, 0); }).observe(picker, { subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Live Yotpo bottomline for the swim-reviews header (metafields lag ~1 day). Falls back to server-rendered values. */
(function () {
  if (window.__swimBottomline) return; window.__swimBottomline = true;
  function run() {
    var el = document.querySelector('[data-swim-bottomline]');
    if (!el || !window.fetch) return;
    var id = el.getAttribute('data-product-id');
    fetch('https://api-cdn.yotpo.com/products/47JNMjISg4TTd6LPuqMGpzgizcyESG5sjMqms28X/' + id + '/bottomline')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var b = d && d.response && d.response.bottomline;
        if (!b || !b.total_reviews) return;
        el.querySelector('[data-swim-avg]').textContent = (Math.round(b.average_score * 10) / 10).toFixed(1);
        el.querySelector('[data-swim-cnt]').textContent = Number(b.total_reviews).toLocaleString('en-AU');
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Swim length toggle: carry the chosen size across to the other length, and re-select it there. */
(function () {
  if (window.__swimLength) return; window.__swimLength = true;
  function chosenSize() {
    var c = Array.prototype.find.call(document.querySelectorAll('.product__variants-wrapper .product__chip.selected'), function (e) { return e.offsetHeight > 0; });
    return c ? c.getAttribute('data-option-value') : '';
  }
  function init() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-swim-length-link]');
      if (!a) return;
      var s = chosenSize();
      if (!s) return;
      var u = new URL(a.getAttribute('href'), location.origin);
      u.searchParams.set('size', s);
      a.setAttribute('href', u.pathname + u.search);
    }, true);
    var want = new URLSearchParams(location.search).get('size');
    if (!want || !document.querySelector('[data-swim-length]')) return;
    var tries = 0;
    function label() {
      var l = Array.prototype.find.call(document.querySelectorAll('[data-selected-value-for-option]'), function (e) { return e.offsetHeight > 0; });
      return l ? l.textContent.trim() : '';
    }
    function cleanUrl() {
      var q = new URLSearchParams(location.search); q.delete('size');
      var qs = q.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    }
    function pick() {
      if (label() === want) { cleanUrl(); return; }
      if (++tries > 12) { cleanUrl(); return; }
      var chip = Array.prototype.find.call(document.querySelectorAll('.product__variants-wrapper .product__chip'), function (e) {
        return e.offsetHeight > 0 && e.getAttribute('data-option-value') === want;
      });
      if (chip) chip.click();
      setTimeout(pick, 400);
    }
    function start() { setTimeout(pick, 300); }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
